<template>
  <div id="livegoodsHq">
    <topNav typeName vuePage="#livegoodsHq" title="带货获取" back="1" closeweb="1" dark="1"></topNav>

    <div class="top_con relativeItem">
      <img class="imgBlock noevents-img" src="../../assets/images/bg_02.png" />
      <div class="absoluteItem topmain centerX">
        <p class="kequ_text">可拾取珍珠（个）</p>
        <div class="zhen_center relativeItem">
          <p class="zhen_num">{{money}}</p>
          <div @click="selectTime" class="timeImg absoluteItem">
            <img class="imgBlock noevents-img" src="../../assets/images/icon_time.png" />
          </div>
        </div>
        <div class="bot_explain flex-box">
          <p>未结算珍珠：</p>
          <p>{{wjs_money}}</p>
          <p>（个）</p>
          <div class="explainimg" @click="showBox = true">
            <img class="imgBlock noevents-img" src="../../assets/images/img00.png" />
          </div>
        </div>
      </div>
    </div>

    <!-- 列表区域 -->
    <div>
      <ul class="goods_ul" v-if="goodsList.length != 0">
        <li class="flex-box" v-for="(n,i) in goodsList" :key="i" @click="goGoodsInfo(n)">
          <div class="gimg_box relativeItem">
            <img class="absoluteItem gimg imgBlock noevents-img centerImg" :src="n.good_thumb" />
          </div>
          <div class="good_info">
            <div class="good_name flex-box">
              <p class="apostrophe">{{n.goods_name}}</p>
              <p class="jsz_money jisuan1" v-if="n.show_status == 1">{{n.money}}</p>
              <p class="jsz_money jisuan2" v-if="n.show_status == 2">+{{n.money}}</p>
              <p class="jsz_money jisuan3" v-if="n.show_status == 3">{{n.money}}</p>
            </div>
            <p class="g_num">×{{n.nums}}</p>
            <div class="good_date flex-box">
              <div>{{n.create_time | timestamp}}</div>
              <div class="jsz_state jisuan1" v-if="n.show_status == 1">结算中</div>
              <div class="jsz_state jisuan3" v-if="n.show_status == 3">已退款</div>
            </div>
          </div>
        </li>
      </ul>
      <!-- 空数据的展示 -->
      <div class="none" v-else>
        <img src="../../assets/images/black.png" />
        <p>暂无带货获取记录</p>
      </div>
      <div class="nomore" v-if="showNomore">--没有更多了--</div>
    </div>

    <!-- 结算说明的提示 -->
    <div class="tc relativeItem" v-show="showBox" @click="showBox = false">
      <div @click.stop class="mainText absoluteItem centerImg">
        <h3>结算说明</h3>
        <p>1.若买家在确认收货且未申请售后，十个工作日后，未结算收益会立即发放到带货收益中；</p>
        <p>2.若买家申请「售后-换货」，则重新计算未结算收益时间；</p>
        <p>
          3.若买家申请「退货/退款」，则未结算收益不予结算，若买家在默认的第十天仍未对订单做「签收/售后」处理，
          系统默认订单状态为已签收，并结算收益。
        </p>
      </div>
    </div>

    <!-- 时间筛选选择框 -->
    <div class="tc relativeItem" v-show="showpicker" @click="showpicker = false">
      <div @click.stop class="absoluteItem pickerBox">
        <picker
          title="时间筛选"
          show-toolbar
          :columns="columns"
          visible-item-count="4"
          confirm-button-text="确定"
          @confirm="onConfirm"
          @cancel="showpicker = false;"
        />
      </div>
    </div>
  </div>
</template>





<script>
// pay_status 支付状态 1=未付款 2=已付款 3=退款
// show_status 1 未結算 2结算 3退款
import topNav from "../index/top_nav";
import Picker from "vant/lib/picker";
import "vant/lib/picker/style";

export default {
  name: "livegoodsHq",
  components: {
    topNav,
    Picker,
  },
  data() {
    return {
      showBox: false,
      showpicker: false,
      columns: ["全部", "近3天", "近1周", "近1月"],
      money: "",
      wjs_money: "",
      goodsList: [],
      page: 1,
      showEmpty: false,
      showNomore: false,
    };
  },
  mounted() {
    this.$tool.setTitle("带货获取");
    setTimeout(() => {
      this.getGoodsInfo();
    }, 200);

    this.$appAc.app_refreshUsable(0); //阻止安卓的刷新
    setTimeout(() => {
      let topnavH = document.querySelector("#top_nav").clientHeight;
      document.querySelector(".top_con").style.top = topnavH + "px";
    }, 300);
  },
  methods: {
    // 时间筛选的框弹出
    selectTime() {
      this.showpicker = true;
    },

    // 获取商品信息
    getGoodsInfo() {
      let _this = this;
      let data = {
        page: _this.page,
      };
      this.$jsonp(this.$apis("live_good_hq"), data, (res) => {
        _this.money = res.data.data.result.list.money;
        _this.wjs_money = res.data.data.result.list.wjs_money;
        _this.goodsList = _this.goodsList.concat(
          res.data.data.result.list.lists
        );
        if (res.data.data.result.list.lists.length != 0 && data.page === 1) {
          setTimeout(() => {
            _this.scrollgetmore();
          }, 400);
        } else if (
          res.data.data.result.list.lists.length === 0 &&
          data.page === 1
        ) {
          _this.showEmpty = true;
        } else if (
          res.data.data.result.list.lists.length === 0 &&
          data.page != 1
        ) {
          _this.showNomore = true;
        }
      });
    },

    // 加载更多
    scrollgetmore() {
      let _this = this;
      let fall = 0;
      window.onscroll = function () {
        fall =
          _this.$tool.getScrollHeight() -
          (_this.$tool.getScrollTop() + _this.$tool.getWindowHeight());
        if (!_this.showNomore && fall <= 50) {
          _this.page++;
          _this.getGoodsInfo();
        }
      };
    },

    // 时间筛选的点击确认
    onConfirm(value, index) {
      if (index == 0) {
        // 点击全部发送请求获取第一页数据，不需要time
        let _this = this;
        let data = {
          page: 1,
        };
        this.$jsonp(this.$apis("live_good_hq"), data, (res) => {
          _this.goodsList = res.data.data.result.list.lists;
          _this.showpicker = false;
          _this.showNomore = false;
        });
      } else {
        // 发送请求  time为1  2  3 分别请求 "近3天", "近1周", "近1月"
        let _this = this;
        let data = {
          time: index,
          page: 1,
        };
        this.$jsonp(this.$apis("live_good_hq"), data, (res) => {
          _this.goodsList = res.data.data.result.list.lists;
          if (_this.goodsList == []) {
            _this.showEmpty = true;
          }
          _this.showpicker = false;
          _this.showNomore = false;
        });
      }
    },

    // 跳转到到货详情
    goGoodsInfo(n) {
      // 缓存中存入点击的数据
      localStorage.setItem("goodHq", JSON.stringify(n));
      this.$router.push({ path: "/liveHqD" });
    },
  },
};
</script>









<style>
#livegoodsHq .c-bk {
  background: url("../../assets/images/bg_01.png") no-repeat;
  background-size: 100% 100%;
}
</style>
<style scoped>
#livegoodsHq {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}
.topmain {
  width: 90%;
  bottom: 0;
}
.top_con {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 2;
}
.kequ_text {
  color: #fff;
  font-size: 15px;
}
.zhen_num {
  font-weight: bold;
  color: #fff;
  font-size: 30px;
  margin-top: 16px;
}
.bot_explain {
  border-top: 1px solid #59c5d0;
  padding: 18px 0;
  margin-top: 22px;
  align-items: center;
}
.topmain .explainimg {
  width: 16px;
  height: 16px;
}
.explainimg img {
  width: 100%;
}
.timeImg {
  width: 22px;
  height: 22px;
  right: 0;
  bottom: -2px;
}
.bot_explain p:nth-child(1),
.bot_explain p:nth-child(3) {
  color: #a4dde4;
  font-size: 15px;
}
.bot_explain p:nth-child(2) {
  color: #fff;
  font-weight: bold;
  font-size: 18px;
}
/* 列表区域 */
.goods_ul {
  padding: 0 16px;
}
.gimg_box {
  width: 55px;
  height: 55px;
  border-radius: 8px;
  overflow: hidden;
}
.goods_ul li {
  padding-bottom: 16px;
}
.goods_ul li:nth-child(1) {
  padding-top: 16px;
}
.goods_ul .gimg {
  width: 100%;
}
.good_info {
  width: calc(100% - 80px);
  margin-left: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}
.good_info .good_name {
  width: 100%;
  justify-content: space-between;
}
.good_name p:nth-child(1) {
  width: 65%;
  color: #333;
  font-size: 15px;
}
.g_num {
  color: #333;
  font-size: 13px;
  margin: 8px 0;
}
.good_date {
  justify-content: space-between;
}
.good_date div:nth-child(1) {
  color: #999;
  font-size: 13px;
}
.jsz_state {
  color: #ff6161;
  font-size: 13px;
}
.jsz_money {
  color: #ff6161;
  font-size: 18px;
}

/* 空数据的展示 */
.none img {
  width: 150px;
  height: 150px;
}
.none p {
  color: #999;
  font-size: 14px;
}
.none {
  height: calc(100vh - 250px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.mainText {
  background-color: #fff;
  width: 75%;
  border-radius: 16px;
  padding: 30px 20px;
}
.mainText h3 {
  width: 100%;
  text-align: center;
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
}
.mainText p {
  color: #999;
  font-size: 12px;
  line-height: 1.7;
}
.pickerBox {
  width: 100%;
  bottom: 0;
  left: 0;
  animation: show 0.5s;
}
/* 结算了的样式 */
.jisuan2 {
  color: #0e9eb5;
}
/* 未结算的样式 */
.jisuan1 {
  color: #ff6161;
}
/* 退款的样式 */
.jisuan3 {
  color: #999999;
}
.nomore {
  margin-top: 12px;
  padding-bottom: 20px;
  width: 100%;
  color: #ccc;
  font-size: 13px;
  text-align: center;
}
</style>